<div class="toggle-switch">
    <div
        class="toggle-option not-included"
        [class.active]="currentValue === 0"
        (click)="toggleState()">
        Not Included
    </div>
    <div
        class="toggle-option all"
        [class.active]="currentValue === 1"
        (click)="toggleState()">
        All
    </div>
    <div
        class="toggle-option included"
        [class.active]="currentValue === 2"
        (click)="toggleState()">
        Included
    </div>
    <div class="toggle-indicator" [ngStyle]="{ left: indicatorPosition }"></div>
</div>
